module.exports = __webpack_public_path__ + "img/realtime_ico.053fd9a9.png";